import React, { ReactNode } from 'react';
import { TableCell, TableRow } from '@mui/material';

type WeightedTableRowProps = {
  header: string;
  value: ReactNode;
};

export const WeightedTableRow = ({ header, value }: WeightedTableRowProps) => {
  return (
    <TableRow>
      <TableCell style={{ fontWeight: 600, width: 200, borderBottom: 'none', paddingBottom: 10, paddingTop: 10 }}>
        {header}
      </TableCell>
      <TableCell style={{ borderBottom: 'none', paddingBottom: 10, paddingTop: 10 }}>{value}</TableCell>
    </TableRow>
  );
};
